import { createStore } from "solid-js/store";
import type { Deploy } from "@houston/shared";

const [deploys, setDeploys] = createStore<{ recent: Deploy[] }>({ recent: [] });

export function addDeploy(d: Deploy) {
  setDeploys("recent", (prev) => [d, ...prev].slice(0, 50));
}

export { deploys };
